import { UserAddress } from 'components/user/model/User';
import { useAuth } from 'lib/useAuth';
import { EGAEventName, useGAHelpers } from 'lib/useGAHelpers';
import React from 'react';
import { addressApi } from '../addressApi';

export function useUserAddressDelete(
    onSuccess: (data: UserAddress[]) => void,
    onError: (message?: string) => void
) {
    const { user } = useAuth();
    const [loading, setLoading] = React.useState(false);
    const { logUserEvent } = useGAHelpers();
    const handleDelete = React.useCallback(
        async (id: string) => {
            try {
                logUserEvent(EGAEventName.AddressDeleteRequested);
                if (!user?.id) {
                    throw new Error();
                }
                setLoading(true);
                const result = await addressApi.delete(user?.id, id);
                onSuccess(result);
            } catch (e: any) {
                onError(e?.data?.message ?? undefined);
            } finally {
                setLoading(false);
            }
        },
        [logUserEvent, onError, onSuccess, user?.id]
    );
    const handleAddressDelete = React.useCallback(
        (id: string) => {
            handleDelete(id);
        },
        [handleDelete]
    );
    const handleSwipeDelete = React.useCallback(
        (id: string) => () => {
            handleDelete(id);
        },
        [handleDelete]
    );
    return {
        deleteLoading: loading,
        onSwipeDelete: handleSwipeDelete,
        onDelete: handleAddressDelete
    };
}
